import {orderBy} from 'lodash'
import React from 'react'
import ListBox from '../listbox'
import {Consumer} from '../../context'

function groupRelevance (group, course) {
  if (!course) return 1
  if (group.course == course) return 1
  if (group.course[1] == course[1]) return 2
  return 3
}

export default function SelectGroup(props) {

  const {selectedGroup, onClick} = props

  return (<Consumer>{ context => {

    const groups = context.groups.map(group => {
      return {
        ...group,
        relevance: groupRelevance(group, context.course),
        selected: (group.id == selectedGroup.id)
      }
    })

    return (
      <ListBox
        className= "select-group"
        labelId= "group_label"
        items= {orderBy(groups, ['relevance', 'course'])}
        onClick = {onClick}
        />)
  }}</Consumer>)
}
